import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useContext } from 'react';
import SessionContext from '../../contexts/SessionContext';
import API_URL from '../../constants/environment';
import {
    SearchInventoryBinsInput,
    SearchInventoryBinsResponse,
} from '../../types/inventory';

const searchInventoryBins = async (
    sessionId: string,
    input: SearchInventoryBinsInput,
): Promise<SearchInventoryBinsResponse> => {
    const { data } = await axios.post(`${API_URL}/inventory/bins/search`, input, {
        headers: { Authorization: sessionId },
    });
    return data;
};

export const useSearchInventoryBins = (
    locationIds: Array<string> | 'all' | null | undefined,
    search: string = '',
    limit: number = 20,
    enabled: boolean = true,
) => {
    const sessionContext = useContext(SessionContext);
    const hasLocationScope =
        locationIds === 'all' || (Array.isArray(locationIds) && locationIds.length > 0);

    return useQuery({
        queryKey: [
            '/inventory/bins/search',
            sessionContext?.organizationId ?? '',
            locationIds === 'all' ? 'all' : (locationIds ?? []).join(','),
            search,
            limit,
        ],
        queryFn: () =>
            searchInventoryBins(sessionContext?.sessionId ?? '', {
                locationIds: locationIds === 'all' ? 'all' : (locationIds as Array<string>),
                search: search || undefined,
                limit,
            }),
        enabled: !!sessionContext?.sessionId && hasLocationScope && enabled,
        staleTime: 30_000,
    });
};
